const SimCardDeviceDataModule = {
  namespaced: true,
  state: {
    deviceGroups: null,
    deviceGroupsLoadingStatus: '',
    deviceCheckItemized: true
  },
  getters: {
    deviceGroups: (state) => {
      return Object.values(window.$gqlpre.deviceGroups.articleGroups)
    },
    deviceGroupsLoadingStatus: (state) => {
      return state.deviceGroupsLoadingStatus
    },
    deviceManufacturers: (state) => {
      return Object.values(window.$gqlpre.deviceGroups.articleLists.manufacturers)
    },
    deviceTypes: (state) => {
      return Object.values(window.$gqlpre.deviceGroups.articleLists.deviceTypes)
    },
    deviceCheckItemized: (state) => {
      return state.deviceCheckItemized
    }
  },
  actions: {
    async getDeviceGroupList ({ state, commit, rootGetters }) {
      // check for prefetched data
      if (state.deviceGroupsLoadingStatus !== 'LOADED') {
        if (typeof window.$gqlpre.deviceGroups !== 'undefined') {
          const data = Object.values(window.$gqlpre.deviceGroups)
          commit('storeDeviceGroups', data)
          commit('storeDeviceGroupsLoadingStatus', 'LOADED')
        } else {
          commit('storeDeviceGroupsLoadingStatus', 'ERROR')
        }
      }
    }
  },
  mutations: {
    storeDeviceGroups: (state, data) => {
      state.deviceGroups = data
    },
    storeDeviceGroupsLoadingStatus: (state, status) => {
      state.deviceGroupsLoadingStatus = status
    },
    storeDeviceCheckItemized: (state, status) => {
      state.deviceCheckItemized = status
    }
  }
}

export default SimCardDeviceDataModule
